import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/bob/right_back.png";

function Introbob() {
  return (
    <section
      className="intro_bob p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ fontWeight: "400", color: "#000" }}>
              <strong>Introduction To B.O.B</strong> The B.O.B Application
              Brings the Modern Method of Business Listing to Life.
            </h2>
            <p>
              B.O.B is an ultra-modern app that lets you list your business
              easily and conveniently over the internet. The app acts more like
              a local guide to your audience. It helps you amplify your online
              presence, increase brand awareness, improve your online visibility
              and strengthen your business credibility in the eyes of your
              audience and search engines.
            </p>
            <p>
              Simultaneously, the B.O.B app also gives the users more options to
              explore and navigate the market to get a better idea of what’s
              going on out there.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="intro_img">
              <StaticImage
                src="../../../images/case-studies/bob/intro_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={734}
                height={672}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introbob;
